import { Box } from '@mantine/core'
import { FieldRenderer } from './FieldRenderer'
import { SectionCard } from '../layout/SectionCard'
import classes from '../../styles/StudioEditorV2.module.css'

/**
 * Renders one card from `schema.ui.groups`: fields gathered out of the schema's own
 * sections and laid out on the Figma two-column grid, with `ui.width: "full"` spanning.
 *
 * Field types that need the whole row regardless of what the schema asked for (image
 * editors, rich text, the thumbnail grids) are forced full-width so a template author
 * cannot accidentally halve them.
 */
const alwaysWide = new Set([
  'segmented',
  'image',
  'image-editor',
  'focal-point',
  'rich-text',
  'textarea',
  'string-list',
  'contact-list',
])

const wideControls = new Set(['thumbnail-grid'])

function isWide(field) {
  const ui = field.ui || {}
  if (wideControls.has(ui.control)) return true
  if (ui.width === 'full') return true
  if (ui.width === 'half') return false
  return alwaysWide.has(field.type)
}

export function SchemaGroup({
  group,
  templateManifest,
  configuration,
  errors,
  updateValue,
  addAsset,
  addRenditionPreview,
  assetUrls,
  assetSourceUrls,
  leading = null,
  children,
}) {
  return (
    <SectionCard
      title={group.title}
      description={group.description}
      collapsible={group.collapsible === true}
      defaultOpen={group.defaultOpen !== false}
    >
      <div className={classes.fieldGrid}>
        {leading && <Box className={classes.fullField}>{leading}</Box>}
        {(group.fields || []).map((field) => (
          <Box
            key={field.path}
            className={isWide(field) ? classes.fullField : undefined}
          >
            <FieldRenderer
              field={field}
              templateManifest={templateManifest}
              configuration={configuration}
              error={errors[field.path]}
              onChange={updateValue}
              addAsset={addAsset}
              addRenditionPreview={addRenditionPreview}
              assetUrls={assetUrls}
              assetSourceUrls={assetSourceUrls}
            />
          </Box>
        ))}
      </div>
      {children}
    </SectionCard>
  )
}
